import { render, staticRenderFns } from "./auth-claim-list.vue?vue&type=template&id=19e9ded0&"
import script from "./auth-claim-list.vue?vue&type=script&lang=js&"
export * from "./auth-claim-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports